const helperEmails = new Set([
  "onixapptester@onix-pu.hr",
  "onixapptester@gmail.com",
]);

export const isMissingAccountEmail = (email?: string | null): boolean => {
  const normalized = email?.trim().toLowerCase();
  return !normalized || helperEmails.has(normalized);
};

export const accountEmailDisplayValue = (email?: string | null): string =>
  isMissingAccountEmail(email) ? "" : (email ?? "");
